import { render, staticRenderFns } from "./modelFunction.vue?vue&type=template&id=19ae59b7&scoped=true"
import script from "./modelFunction.vue?vue&type=script&lang=js"
export * from "./modelFunction.vue?vue&type=script&lang=js"
import style0 from "./modelFunction.vue?vue&type=style&index=0&id=19ae59b7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ae59b7",
  null
  
)

export default component.exports